module.exports = __webpack_public_path__ + "static/media/Pop.41eface6.mp3";